<template>
  <div>
    <div v-if="!$parent.isLoad" class="mt--9">
      <div class="card border-0 mb-0">
        <div class="card-body" v-if="!$root.empresa.cancelado">
          <h4 :class="{'mb-4': !$root.empresa.banner_logo}" class="text-center">
            {{ $root.empresa.configs.mensagem }}
          </h4>
          <figure v-if="$root.empresa.banner_logo != null" class="text-center my-1">
            <img :src="$root.empresa.banner_logo" class="img-fluid">
          </figure>

          <div class="text-center text-muted mb-2">
            <small>Autenticação</small>
          </div>

          <div v-if="$parent.error" class="alert alert-danger">{{ $parent.error }}</div>

          <form @submit.prevent="onLogin">
            <div v-if="$root.empresa.is_login_cpf" class="form-group">
              <input v-model="fieldCpfCnpj" v-mask="['###.###.###-##', '##.###.###/####-##']" class="form-control"
                     name="cpfcnpj"
                     placeholder="CPF/CNPJ" type="tel">
            </div>

            <div v-if="$root.empresa.is_login_cpf && $root.empresa.is_login_username" class="row mt--4">
              <div class="col">
                <hr>
              </div>
              <div class="col-2 my-auto mx-auto text-center"><small>ou</small></div>
              <div class="col">
                <hr>
              </div>
            </div>

            <div v-if="$root.empresa.is_login_username">
              <div class="form-group">
                <input v-model="fieldUsername" class="form-control" name="login" placeholder="Usuário" type="text">
              </div>
              <div class="form-group">
                <input v-model="fieldPassword" class="form-control" name="password" placeholder="Senha" type="password">
              </div>
            </div>

            <button class="btn btn-default btn-block" type="submit">Acessar</button>
          </form>
        </div>
        <div class="card-body" v-else>
          <div class="text-muted mb-2">
            <h3 class="text-danger">Prezado Assinante,<br><br>central do assinante foi desativada.</h3>
          </div>
        </div>
      </div>

      <div class="card mb-0 border-0 mt-4" v-if="!$root.empresa.cancelado">
        <a :href="urlApp" target="_blank">
          <div class="row no-gutters align-items-center">
            <div class="col-3 col-md-4">
              <img alt="aplicativo" class="img-fluid"
                   src="data:image/png;base64,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">
            </div>
            <div class="col ">
              <div class="card-body">
                <p class="card-text">Abra o Aplicativo da Central do Assinante em seu Telefone</p>
              </div>
            </div>
          </div>
        </a>
      </div>

      <div class="card mb-0 border-0 mt-4">
        <div class="card-body">
          <div class="row row-cols-2">
            <div class="col-12 mb-3">
              <strong>Serviços</strong>
            </div>
            <div class="col">- Consultar Extrato;</div>
            <div class="col">- Plano de Acesso;</div>
            <div class="col">- Segunda Via de Boleto;</div>
            <div class="col">- Dados Cadastrais.</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Login",
  data: function () {
    return {
      fieldCpfCnpj: '',
      fieldUsername: '',
      fieldPassword: '',
    }
  },
  computed: {
    urlApp: function () {
      let os = this.$root.getMobileOS()
      if (os === 'Android' && this.$root.empresa.configs.app_android) {
        return this.$root.empresa.configs.app_android;
      } else if (os === 'iOS' && this.$root.empresa.configs.app_ios) {
        return this.$root.empresa.configs.app_ios;
      }

      return this.$root.empresa.configs.app_web
    },
  },
  created() {
    this.$parent.loadEmpresa(function () {
      if (this.$route.params.cpfcnpj !== undefined) {
        this.fieldCpfCnpj = this.$route.params.cpfcnpj
        this.onLogin()
      } else if (this.$route.params.username !== undefined
          && this.$route.params.password !== undefined) {
        this.fieldUsername = this.$route.params.username
        this.fieldPassword = this.$route.params.password
        if (this.$route.params.idEmpresa !== undefined) {
          this.$parent.loadEmpresa(function () {
            this.onLogin()
          }.bind(this), this.$route.params.idEmpresa)
        } else {
          this.onLogin()
        }
      }
    }.bind(this))
  },
  methods: {
    onLogin: function () {
      let cpfcnpj = this.fieldCpfCnpj.replace(/[^0-9]/g, '')
      let data = {
        client_id: process.env.VUE_APP_OAUTH2_CLIENT_ID,
        client_secret: process.env.VUE_APP_OAUTH2_CLIENT_SECRET,
      }
      if (this.$root.empresa.is_login_cpf && (cpfcnpj.length === 11 || cpfcnpj.length === 14)) {
        data['cpfcnpj'] = cpfcnpj
      } else if (this.$root.empresa.is_login_username && this.fieldUsername.length > 0 && this.fieldPassword.length > 0) {
        data['username'] = this.fieldUsername
        data['password'] = this.fieldPassword
      }
      if (this.$root.empresa.id > 0) {
        data['idEmpresa'] = this.$root.empresa.id;
      }

      if (data.cpfcnpj !== undefined || data.username !== undefined) {
        this.$parent.authenticate(data)
      } else {
        this.$parent.error = 'Falha na autenticação. Verifique.'
      }
    },
  }
}
</script>

<style scoped>
.header {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 500px;
}

.form-control {
  text-align: center;
}
</style>